import {AbstractControl} from '@angular/forms';

export function NotZero(control: AbstractControl) {
  if (control.value !== null) {
    if (control.value === 0 || control.value === '0') {
      return {
        notZero: true
      };
    }
  }
  return null;
}
